<template>
<!-- 海报列表 -->
    <div class="el-card  pd20">
        <!-- add---新增 -->
        <div class="box">
            <router-link to="/main/posters_management_form">
                <el-button type="primary" size="medium">新建海报</el-button>
            </router-link>
            <!--  -->
            <div class="search">
                关联课程
                <el-select class="search-child" v-model="status" placeholder="请选择关联课程" clearable>
                    <el-option  v-for="(item,index) in course_list" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
                </el-select>
                <!-- 搜索 -->
                <el-button type="primary" class="search-child btn" @click="pullData" round  size="medium">搜索</el-button>
            </div>

        </div>
        <!--  -->
        <div class="el-card  pd20 content">
            <el-table :data="list" border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="80" label="序号"></el-table-column>
                <el-table-column label="课程名称" >
                    <template slot-scope="scope">
                        <!-- 因为for比if先执行，所以循环判断是否相等，如果相等显示课程名称 -->
                        <span v-if="item.id == scope.row.course_id" v-for="(item,index) in course_list" :key="index">{{item.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="海报类型" >
                    <template slot-scope="scope">{{scope.row.type===0?'转介分享':'下级招募'}}</template>
                </el-table-column>
                <el-table-column prop="describe" label="海报描述" > </el-table-column>
                <el-table-column label="背景图" >
                    <template slot-scope="scope">
                        <img class="table-img" :src="scope.row.backimg" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="headimg" label="头像位置" > </el-table-column>
                <el-table-column prop="headsize" label="头像大小" > </el-table-column>
                <el-table-column prop="nickname" label="昵称位置" > </el-table-column>
                <el-table-column prop="nicknamefontcolor" label="昵称颜色" > </el-table-column>
                <el-table-column prop="nicknamefontsize" label="昵称字体大小" > </el-table-column>
                <el-table-column prop="qrcodeurl" label="二维码链接" > </el-table-column>
                <el-table-column prop="qrcode" label="二维码位置" > </el-table-column>
                <el-table-column prop="qrcodesize" label="二维码大小" > </el-table-column>
                <el-table-column prop="status" label="状态" >
                    <template slot-scope="scope">{{scope.row.status===0?'生效':'失效'}}</template>
                </el-table-column>
                <el-table-column prop="sort" label="生成图片的排序" > </el-table-column>
                <el-table-column width="100" label="操作" >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.$index, scope.row,'edit')" circle></el-button>
                        <el-button  size="mini" icon="el-icon-view" @click="view(scope.$index, scope.row,'edit')" circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination class="pages"
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pages.size"
                :current-page="pages.page"
                background
                layout="sizes,prev, pager, next"
                :total="pages.count">
            </el-pagination>
        </div>
        <!-- 海报预览 -->
        <el-dialog title="海报预览" :visible.sync="preview" width="40%">
            <img v-if="preview_img" class="preview_img" :src="preview_img" alt="">
            <span slot="footer" class="dialog-footer">
                <el-button @click="preview = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { postersList,missionCamp,postersPreview } from "@/api/operating";
export default {
    data() {
        return{
            pages:{},
            list:[],
            //
            status:null,
            course_list:[],
            obj:{},
            preview:false,
            preview_img:''
        }
    },
    methods:{
        // 查看
        view(index,row){
            postersPreview({
                id:row.id
            }).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.preview_img = data.list.url;
                this.preview = true;
            });
        },
        // 修改
        edit(index,row){
            this.$router.push({
                path:'/main/posters_management_form',
                query:{
                    id:row.id,
                    type:'edit'
                }
            });
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();

            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };
            if(this.status !==null){
                this.obj['status'] = this.status;
            }

            let arr1 =  postersList(this.obj);

            let arr2 =  missionCamp();

            Promise.all([arr1,arr2]).then((data)=>{
                this.list = data[0].list;
                this.pages = data[0].pager;

                //
                this.course_list = data[1].list;

                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.headimgurl{
    width: 100px;
    height: 100px;
}
.box{
    margin-bottom: 20px;
    display: flex;
}
.content{
    padding: 20px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.search{
    text-align: right;
    display: flex;
    align-items: center;
    margin-left: auto;
}
.search-child{
    width: auto;
    margin-left: 20px;
}
.search-child.btn{
    margin-left: 20px;
}
.table-img{
    width: 100%;
}
.preview_img{
    width: 100%;
}
</style>
